<template>
    <!-- main section -->
        <section class="hero is-flex main">
            <div class="card" style="width: 100%;">
                <div class="card-content">
                        <div class="img1 practice-bg"><img src="../assets/images/cap.png" alt=""></div>
                        <div class="img3 practice-bg"><img src="../assets/images/clock.png" alt=""></div>
                        <div class="img4 practice-bg">
                            <div class="img4-inner">
                                <img class="pencil" src="../assets/images/pencil.png" alt="">
                                <img src="../assets/images/bird.png" alt="">
                            </div>
                            
                        </div>
                        <div class="img5 practice-bg"><img src="../assets/images/stars.png" alt=""></div>
                        <div class="img6 practice-bg"><img src="../assets/images/rainbow2.png" alt=""></div>
                        <div class="img7 practice-bg"><img src="../assets/images/cloud4.png" alt=""></div>
                    <div class="tabs">
                        <ul>
                            <li class="active">
                                <a href="practice">
                                    <span style="color: #fff;font-weight: bold;">Practice</span>
                                </a>
                            </li>
                            <li>
                                <a href="analytics">
                                    <span>Analytic</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div id="tab-content">
                        <div class="practice-tab" id="practice">
                            <b-loading :is-full-page="true" v-model="isLoading"></b-loading>
        
                            <div class="card-container">
                                <div 
                                    class="practice-card" 
                                    v-for="(grade, gradeIndex) in fetchGradeSubjects" 
                                    :key="grade._id" 
                                    :class="{ 'coming-soon-card': isComingSoon(gradeIndex) }"
                                    :style="`border-left: 5px solid ${grade.theme_color}`"
                                >
                                    <div class="card-header" :style="`border-bottom: 1px solid ${grade.theme_color}20`">
                                        <div class="card-title" :style="`color: ${grade.theme_color}`">{{ grade.name }}</div>
                                        <div 
                                            class="card-badge" 
                                            :style="isComingSoon(gradeIndex) ? 'background: #ffa500; color: white' : `background: ${grade.theme_color}; color: white`"
                                        >
                                            {{ isComingSoon(gradeIndex) ? 'Coming Soon' : 'Grade' }}
                                        </div>
                                    </div>
                                    <div class="card-description">{{ grade.description }}</div>
                                    <div class="subjects-container">
                                        <button 
                                            v-for="subject in grade.subjects" 
                                            :key="`${grade._id}_${subject.subject._id}`"
                                            class="subject-button"
                                            :class="{ 'subject-disabled': isComingSoon(gradeIndex) }"
                                            :style="getSubjectButtonStyle(grade.theme_color, gradeIndex)"
                                            :disabled="isComingSoon(gradeIndex)"
                                            @click="!isComingSoon(gradeIndex) && $router.push({ name: 'kiddetail_categories', params: { kid_id, grade_subject_id: subject.grade_subject } })"
                                        >
                                            <div class="subject-icon" :style="getSubjectIconStyle(grade.theme_color, gradeIndex)">
                                                <span v-if="!isComingSoon(gradeIndex)">{{ subject.subject.name.charAt(0) }}</span>
                                                <span v-else>🔒</span>
                                            </div>
                                            <span class="subject-name">
                                                {{ subject.subject.name }}
                                            </span>
                                        </button>
                                    </div>
                                    <div v-if="isComingSoon(gradeIndex)" class="coming-soon-overlay">
                                        <div class="coming-soon-text">
                                            <span class="coming-soon-icon">🚀</span>
                                            <span>Coming Soon!</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
  </template>
  <script>
  import { mapGetters, mapActions } from 'vuex'
  export default {
    name: 'Practice',
    components: {
    },
    props : {
      kid_id : {
        type : String,
        required : true
      }
    },
    data() {
      return {
        isLoading: false,
      }
    },
    methods: {
      ...mapActions(['loadKids', 'loadGradeSubjects']),
      isComingSoon(gradeIndex) {
        // Make last 2 grade subjects "Coming Soon"
        return gradeIndex >= this.fetchGradeSubjects.length - 2;
      },
      getSubjectButtonStyle(themeColor, gradeIndex) {
        if (this.isComingSoon(gradeIndex)) {
          return 'border-color: #cccccc; background: #f5f5f5; opacity: 0.6; cursor: not-allowed;';
        }
        return `border-color: ${themeColor}30; background: ${themeColor}10`;
      },
      getSubjectIconStyle(themeColor, gradeIndex) {
        if (this.isComingSoon(gradeIndex)) {
          return 'background: #e0e0e0; color: #999999;';
        }
        return `background: ${themeColor}20; color: ${themeColor}`;
      }
    },
    computed: {
      ...mapGetters(['getUserType', 'getTeacherToken', 'fetchGradeSubjects', 'fetchKids', 'fetchColors']),
    },
    created() {
      this.isLoading = true
      this.loadKids({
        token: this.getTeacherToken
      })
      this.loadGradeSubjects({
        token: this.getTeacherToken,
        filter: {
          details: true,
          status: true
        }
      }).then(() => {
        this.isLoading = false
      })
    }
  
  
  } 
  </script>
  <style scoped>
  .flex {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .container {
    position: relative;
  }
  
  .bg-img {
    display: flex;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
  }
  .bg-img div {
    display: flex;
    position: absolute;
    width: auto;
  }
  
  .title {
    font-size: 3vw;
    margin: 0 !important;
  }
  
  img {
    width: 100%;
    height: 100%;
    object-fit: fill;
  }
  
  .button {
    flex-direction: row;
    padding: 1vw 1.25vw;
    width: 100%;
    background: #8919e7;
    border-radius: 1vw;
    color: #fff;
    gap: 1vw;
    cursor: pointer;
    position: relative;
    text-transform: capitalize;
  }
  .button.outline {
    border: 0.063rem solid #8919e7;
    background: #fff;
    color: #000;
  }
  .link {
    cursor: pointer;
  }
  .main {
    align-items: center;
    margin: 6.76vw 0vw;
    position: relative;
    gap: 2.4vw;
  }
  /* responsive page*/
  
  /* tablet */
  @media screen and (max-width: 1023px) {
    .title{
      font-size: 3.5vw !important;
    }
  }
  
  /* Mobiles */
  @media screen and (max-width: 767px) {
    .title {
      font-size: 4vw !important;
    }
  }
  
  @media screen and (max-width: 467px){
    .title{
      font-size: 5vw !important;
    }
  }
  .practice-bg {
    position: absolute;
    z-index: 10;
  }
  .practice-bg img {
    height: 150px;
    max-width: 100%;
    width: auto;
  }
  
  .img1 {
    top: 0;
    left: 0;
  }
  
  .img3 {
    top: -9%;
    left: 43%;
    z-index: 0;
  }
  
  .img4 {
    right: 4%;
    top: -5%;
  }
  .img4 .img4-inner {
    position: relative;
  }
  .img4 .img4-inner .pencil {
    position: absolute;
    left: -12%;
  }
  
  .img5 {
    right: 13%;
    bottom: 22%;
  }
  .img5 img {
    height: auto;
  }
  
  .img6 {
    right: -5%;
    bottom: 0;
  }
  .img6 img {
    height: auto;
  }
  
  .img7 {
    bottom: 0;
    left: -2%;
    right: -2%;
  }
  
  .main .card {
    box-shadow: none;
  }
  .main .card .card-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
  }
  .main .card .card-content #tab-content {
    background: linear-gradient(75.66deg, rgba(138, 25, 231, 0.1) 9.81%, rgba(49, 200, 255, 0.1) 95.1%);
    border-radius: 30px 30px 0px 0px;
    width: 100%;
    padding: 59px 68px 115px;
  }
  .main .card .card-content #tab-content .card-container {
    display: flex;
    flex-wrap: wrap;
    gap: 32px;
  }
  .main .card .card-content #tab-content .card-container .practice-card {
    display: flex;
    flex-direction: column;
    background: #ffffff;
    border-radius: 20px;
    max-width: 350px;
    flex: 1 1 312px;
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.05);
    overflow: hidden;
    position: relative;
  }
  .main .card .card-content #tab-content .card-container .practice-card:hover {
    transform: none;
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.05);
  }
  .main .card .card-content #tab-content .card-container .practice-card:hover .card-title,
  .main .card .card-content #tab-content .card-container .practice-card:hover .card-description {
    color: inherit;
  }
  .main .card .card-content #tab-content .card-container .practice-card .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 25px;
    border-bottom: 1px solid rgba(225, 225, 225, 0.5);
    position: relative;
  }
  .main .card .card-content #tab-content .card-container .practice-card .card-header::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 5px;
    height: 100%;
    background: transparent;
  }
  .main .card .card-content #tab-content .card-container .practice-card .card-title {
    font-weight: 700;
    font-size: 1.5rem;
    text-transform: capitalize;
  }
  .main .card .card-content #tab-content .card-container .practice-card .card-badge {
    padding: 5px 12px;
    border-radius: 20px;
    font-size: 0.8rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
  .main .card .card-content #tab-content .card-container .practice-card .card-description {
    padding: 20px 25px;
    font-size: 0.95rem;
    line-height: 1.5;
    color: #666;
    border-bottom: 1px dashed rgba(225, 225, 225, 0.7);
  }
  .main .card .card-content #tab-content .card-container .practice-card .subjects-container {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    padding: 20px 25px;
  }
  .main .card .card-content #tab-content .card-container .practice-card .subject-button {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px 15px;
    border: 1px solid;
    border-radius: 12px;
    cursor: pointer;
    transition: all 0.2s ease;
    width: fit-content;
  }
  .main .card .card-content #tab-content .card-container .practice-card .subject-button:hover {
    transform: translateY(-2px);
    opacity: 0.8;
  }
  .main .card .card-content #tab-content .card-container .practice-card .subject-button:hover .subject-name {
    color: inherit;
  }
  .main .card .card-content #tab-content .card-container .practice-card .subject-button:hover .subject-icon {
    opacity: 0.9;
  }
  .main .card .card-content #tab-content .card-container .practice-card .subject-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    font-weight: 700;
    transition: all 0.2s ease;
  }
  .main .card .card-content #tab-content .card-container .practice-card .subject-name {
    font-size: 0.95rem;
    font-weight: 600;
    color: #444;
    transition: color 0.2s ease;
  }
  .main .card .card-content .tabs {
    width: 100%;
    width: 100%;
    justify-content: center;
    margin-bottom: 0;
    z-index: 1;
  }
  .main .card .card-content .tabs ul {
    border: 1px solid #8919e7;
    border-bottom: none;
    border-radius: 28.5px 28.5px 0px 0px;
    justify-content: center;
    width: -webkit-fit-content;
    width: -moz-fit-content;
    width: fit-content;
    flex-shrink: 1;
    max-width: 43.5%;
    background: #fff;
  }
  .main .card .card-content .tabs li.active {
    background: #8919e7;
    border-radius: 28.5px 28.5px 0px 0px;
  }
  .main .card .card-content .tabs li {
    all: unset;
    width: 100%;
    max-width: 50%;
  }
  .main .card .card-content .tabs li a {
    padding: 21px 0 17px;
  }
  
  @media screen and (max-width: 768px) {
    .main .card .card-content #tab-content {
      padding: 25px 20px;
    }
    .practice-bg {
      display: none;
    }
    .card-container {
      justify-content: center;
    }
    .main .card .card-content .tabs ul {
      max-width: 85%;
    }
    .main .card .card-content .tabs li a {
      padding: 10px 0 10px;
    }
  }
  .grade-card {
    padding: 12px 10px 12px 10px;
    border-radius: 5px;
  }
  
  .grade-heading {
    padding: 5px 50px 5px 10px;
    color: #fff;
    border-top-right-radius: 20px;
    border-bottom-right-radius: 20px;
    margin-left: -10px;
  }
  
  .grade-description {
    margin: 14px 0 12px 0;
  }
  
  .grade-subject-label {
    color: #000;
    padding-top: 12px;
  }

  /* Coming Soon Styles */
  .coming-soon-card {
    position: relative;
    opacity: 0.8;
  }

  .coming-soon-card::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, rgba(255, 165, 0, 0.1), rgba(255, 165, 0, 0.05));
    border-radius: 20px;
    pointer-events: none;
    z-index: 1;
  }

  .subject-disabled {
    cursor: not-allowed !important;
    pointer-events: none;
  }

  .subject-disabled:hover {
    transform: none !important;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1) !important;
  }

  .coming-soon-overlay {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: rgba(255, 165, 0, 0.95);
    color: white;
    padding: 12px 20px;
    border-radius: 25px;
    font-weight: bold;
    font-size: 1.1rem;
    box-shadow: 0 8px 25px rgba(255, 165, 0, 0.4);
    z-index: 10;
    animation: pulse 2s infinite;
  }

  .coming-soon-text {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .coming-soon-icon {
    font-size: 1.2rem;
    animation: bounce 1.5s infinite;
  }

  @keyframes pulse {
    0%, 100% { 
      transform: translate(-50%, -50%) scale(1); 
      opacity: 1;
    }
    50% { 
      transform: translate(-50%, -50%) scale(1.05); 
      opacity: 0.9;
    }
  }

  @keyframes bounce {
    0%, 20%, 50%, 80%, 100% { transform: translateY(0); }
    40% { transform: translateY(-5px); }
    60% { transform: translateY(-3px); }
  }

  /* Override subject button styles for coming soon */
  .coming-soon-card .subject-button {
    opacity: 0.7;
  }

  .coming-soon-card .subject-name {
    color: #999 !important;
    font-style: italic;
  }
  </style>